export default class GroupModel {
  name;
  dateArrival = new Date();
  dateDepart = new Date();

}
